import styled from 'styled-components';

import { ButtonBase } from '@material-ui/core';

export const Container = styled(ButtonBase)`
  height: 160px;
  background-color: #cce6ee !important;
  width: 100%;
  margin-bottom: 5px !important;
  position: relative;

  .icon-infusion {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 62px;
    margin-bottom: 10px;
    color: #fff;
  }
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 10px;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #0384ac;
  margin-bottom: 2px;
  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export const Date = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DateText = styled.p`
  font-size: 10px;
  color: #0384ac;
  margin-left: 4px;
`;
